<template><svg viewBox="0 0 32 32" width="32" height="32" xmlns="http://www.w3.org/2000/svg">
	<mask id="a" height="18.7" maskUnits="userSpaceOnUse" width="13.6" x="9" y="6.3">
		<path clip-rule="evenodd" d="M9 6.3h13.6V25H9z" fill="#fff" fill-rule="evenodd" />
	</mask>
	<g clip-rule="evenodd" fill-rule="evenodd">
		<path class="active" d="M24 13.7c-.2 3.1-2.2 6.4-6 10.3-3.8-3.9-5.7-7.3-6-10.3v-.6C12 9.7 14.7 7 18 7s6 2.7 6 6.1z" fill="#ffed00" />
		<g fill="currentColor">
			<path d="M21.6 13.7c-.2 2.9-2.1 6.2-5.8 9.9-3.6-3.7-5.5-7-5.8-9.9v-.6c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8zm-5.8-7.4C12 6.3 9 9.4 9 13.1v.7c.3 3.3 2.4 6.8 6.4 10.8l.4.4.4-.4c4-4 6.1-7.6 6.4-10.8v-.7c0-3.7-3.1-6.8-6.8-6.8" mask="url(#a)" />
			<path d="M15.8 13.1c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4c0-.7-.6-1.4-1.4-1.4" />
		</g>
	</g>
</svg>
</template>